import {
    Component,
    OnInit,
    ViewChild,
    AfterViewInit,
    Output,
    EventEmitter,
    Input,
    ElementRef,
    ChangeDetectionStrategy,
} from "@angular/core";
import { WatchListModel } from "./WatchList.model";
import { CheckBoxComponent } from "../../../check-box/check-box.component";
import { ButtonComponent } from "../../../button/button.component";
import { FormComponent } from "../../../form/form.component";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ServiceStock } from "../../../service-stock.service";
import { GotxComboBoxComponent } from "../../components/gotx-combo-box/gotx-combo-box.component";
import { ExchangeComponent } from "../../components/Exchange/Exchange.component";
import { ProductComponent } from "../../components/Product/Product.component";
import { GotxGridComponent } from "../../components/gotx-grid/gotx-grid.component";
import { gotxModalComponent } from "src/app/gotxModal/gotxModal.component";
import { StockComponent } from "../../components/Stock/Stock.component";
import { UserPreferenceService } from "src/app/user-preference.service";
import { MarketWatchService } from 'src/app/market-watch.service';

const customCss: string = "";

@Component({
    selector: "app-WatchList",
    templateUrl: "./WatchList.component.html",
    changeDetection:ChangeDetectionStrategy.OnPush //added by shanmugapriya
})
export class WatchListComponent
    extends FormComponent
    implements OnInit, AfterViewInit {
    @Input("activeModal") activeModal: NgbActiveModal;
    @ViewChild("FieldId_1", { static: false }) FieldId_1: ElementRef;
    @ViewChild("cmbWatchlist", { static: false })
    cmbWatchlist: GotxComboBoxComponent;
    @ViewChild("chckDefault", { static: false }) chckDefault: CheckBoxComponent;
    @ViewChild("btnAdd", { static: false }) btnAdd: ButtonComponent;
    @ViewChild("btnRemove", { static: false }) btnRemove: ButtonComponent;
    @ViewChild("cstmExchange", { static: false }) cstmExchange: ExchangeComponent;
    @ViewChild("cstmProduct", { static: false }) cstmProduct: ProductComponent;
    @ViewChild("cmbStock", { static: false }) cmbStock: StockComponent;
    @ViewChild("FieldId_19", { static: false }) FieldId_19: ElementRef;
    @ViewChild("GotxGrid", { static: false }) GotxGrid: GotxGridComponent;
    @ViewChild("btnSave", { static: false }) btnSave: ButtonComponent;
    @ViewChild("btnClose", { static: false }) btnClose: ButtonComponent;
    skeletonContentLoaded = false;
    stockInWatchlist = [];
    selectedWatchlist: any;
    returnDataForWatchlist = "";
    ProductFromDropDown = "";
    InitialWatchlist : any;
    CurrentWatchlist = [];
    indicesToRemove: number[] = [];
    initialWatchlistLength:any;
    watchData = [];
    productSelectedWatchlist = this.services.dataStore.getproductMasterData();
   // isfromproductChange : boolean = false;

    async revalidate(): Promise<number> {
        var totalErrors = 0;
        super.beforeRevalidate();
        await Promise.all([
            this.revalidateBasicField("chckDefault"),
            this.cstmExchange.revalidate(),
            this.cstmProduct.revalidate(),
        ]).then((errorCounts) => {
            errorCounts.forEach((errorCount) => {
                totalErrors += errorCount;
            });
        });
        this.errors = totalErrors;
        super.afterRevalidate();
        return totalErrors;
    }

    constructor(
        services: ServiceStock,
        private userPreferenceService: UserPreferenceService, private marketService: MarketWatchService
    ) {
        super(services);
        this.value = new WatchListModel();
        this.componentCode = "WatchList";
    }
    setReadOnly(readOnly) {
        super.setBasicFieldsReadOnly(readOnly);
        this.cstmExchange.setReadOnly(readOnly);
        // this.cstmProduct.setReadOnly(readOnly);
    }
    async onFormLoad() {
        this.setInputs(
            this.services.dataStore.getData(this.services.routing.currModal)
        );
        this.cstmProduct.cmbProduct.dropDownOptions.Options = this.services.dataStore.getcmbProductderivative();
        this.cstmProduct.cmbProduct.setValue(this.cstmProduct.cmbProduct.dropDownOptions.Options[0]);

        this.setDependencies();

        /*if (this.cmbWatchlist.gotxComboBox.getSelectedItem() != null) {
            console.log("--------------onformload");
            this.watchlistChange(this.cmbWatchlist.gotxComboBox.getSelectedItem().value);
        }*/
        this.cmbWatchlist.gotxComboBox.focus();
       /* setTimeout(() => {
            this.reloadStock(); 
          }, 2000);*/
           
        this.reloadStock();
    }
    setInputs(param: any) {
        let params = this.services.http.mapToJson(param);
        if (params["mode"]) {
            this.mode = params["mode"];
        }
    }
    async submitForm(path, apiCode, serviceCode) {
        this.submitData["formName"] = "CreateWatchList";
        await super.submit(path, apiCode, serviceCode);
    }
    getFieldInfo() {
        this.amountComponent.forEach((field) => {
            this.additionalInfo[field.fieldID + "_desc"] = field.getFieldInfo();
        });
        this.comboFields.forEach((field) => {
            this.additionalInfo[field.fieldID + "_desc"] = field.getFieldInfo();
        });
        // this.fileUploadFields.forEach(field => { this.additionalInfo[field.fieldID + '_desc'] = field.getFieldInfo(); });
        this.additionalInfo["cstmExchange_desc"] = this.cstmExchange.getFieldInfo();
        this.additionalInfo["cstmProduct_desc"] = this.cstmProduct.getFieldInfo();
        return this.additionalInfo;
    }
    getFieldValue() {
        this.value.cstmExchange = this.cstmExchange.getFieldValue();
        this.value.cstmProduct = this.cstmProduct.getFieldValue();
        return this.value;
    }
    setValue(inputValue, inputDesc = undefined) {
        this.setBasicFieldsValue(inputValue, inputDesc);
        this.cstmExchange.setValue(
            inputValue["cstmExchange"],
            inputDesc["cstmExchange_desc"]
        );
        this.cstmProduct.setValue(
            inputValue["cstmProduct"],
            inputDesc["cstmProduct_desc"]
        );
        this.value = new WatchListModel();
        this.value.setValue(inputValue);
        this.setDependencies();
        this.passNewValue(this.value);
    }
    setProductField(value: string): void {
        if (value == "EQUITY") {
            this.productSelectedWatchlist = value;
        } else if (value == "FUTCOM" || value == "OPTCOM") {
            this.productSelectedWatchlist = "COMDERV";
        } else if (value == "FUTSTK" || value == "FUTIDX" || value == "OPTSTK" || value == "OPTIDX") {
            this.productSelectedWatchlist = "FUTOPT";
        }
        //this.cstmProduct.cmbProduct.dropDownOptions.Options = this.services.dataStore.getcmbProductderivative();
        //this.cstmProduct.cmbProduct.setValue(value);
    }

    ngOnInit() {
        if (this.formCode == undefined) {
            this.formCode = "WatchList";
        }
        if (this.formOnLoadError) {
            return;
        }
        setTimeout(() => {
            this.skeletonContentLoaded = true;
        }, 1000);
        var styleElement = document.createElement("style");
        styleElement.type = "text/css";
        styleElement.innerHTML = customCss;
        styleElement.id = "WatchList_customCss";
        document.getElementsByTagName("head")[0].appendChild(styleElement);
        // this.stockData = this.services.dataStore.getcmbStock();
        // this.source = this.services.dataStore.getcmbStockInput();
        console.log("this.services.dataStore.getWatchList()",this.services.dataStore.getWatchList());
        this.watchData = this.services.dataStore.getWatchList().filter((item) => item.isCustom == true);
        this.setProductField(this.productSelectedWatchlist);
        //this.ProductFromDropDown = this.cstmProduct.getFieldValue();
    }
    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
        var styleElement = document.getElementById("WatchList_customCss");
        styleElement.parentNode.removeChild(styleElement);
    }
    ngAfterViewInit() {
        setTimeout(() => {
            this.subsBFldsValueUpdates();
            this.value.cstmExchange = this.cstmExchange.getFieldValue();
            this.cstmExchange.valueChangeUpdates().subscribe((value) => {
                this.value.cstmExchange = value;
            });
            this.value.cstmProduct = this.cstmProduct.getFieldValue();
            this.cstmProduct.valueChangeUpdates().subscribe((value) => {
                this.value.cstmProduct = value;
            });
            this.onFormLoad();
            this.checkForHTabOverFlow();
        });
    }
    clearError() {
        super.clearBasicFieldsError();
        super.clearHTabErrors();
        super.clearVTabErrors();
        this.cstmExchange.clearError();
        this.cstmProduct.clearError();
        this.errors = 0;
        this.errorMessage = [];
    }
    onReset() {
        super.resetBasicFields();
        this.cstmExchange.onReset();
        this.cstmProduct.onReset();
        this.clearHTabErrors();
        this.clearVTabErrors();
        this.errors = 0;
        this.errorMessage = [];
        this.additionalInfo = undefined;
        this.dependencyMap.clear();
        this.value = new WatchListModel();
        this.passNewValue(this.value);
        this.setReadOnly(false);
        this.onFormLoad();
    }
    fieldDependencies = {};

    showMessage(id, message) {
        document.getElementById(id).innerHTML = message;
        setTimeout(() => {
            if (document.getElementById(id))
                document.getElementById(id).innerHTML = "";
        }, 3000);
    }

    addWatchlist() {
        this.InitialWatchlist = [];
        this.CurrentWatchlist = [];
        this.initialWatchlistLength = this.services.dataStore.getWatchList().filter((item) => item.isCustom == true);
        //console.log("this.initialWatchlistLength",this.initialWatchlistLength);
        if (this.cmbWatchlist.gotxComboBox.getSelectedItem() != null) {
            this.showMessage("errMsgDiv", "Watchlist already exist");
            // document.getElementById('errMsgDiv').innerHTML = "Watchlist already exist";
        } else if (this.cmbWatchlist.gotxComboBox.val() == "") {
            this.showMessage("errMsgDiv", "Value cannot be empty");
            // document.getElementById('errMsgDiv').innerHTML = "Value cannot be empty";
        } else {
            let newWatchlist = this.cmbWatchlist.gotxComboBox.val();
            if (
                !newWatchlist.toString().match(this.cmbWatchlist.alphaNumericPattern)
            ) {
                this.cmbWatchlist.errorMessage = "WatchList should be alpha numeric";
                this.cmbWatchlist.error = true;
            } else if (!newWatchlist.toString().match(this.cmbWatchlist.upto12)) {
                this.cmbWatchlist.errorMessage =
                    "WatchList length should not exceeds 12 character";
                this.cmbWatchlist.error = true;
            } else {
                this.cmbWatchlist.error = false;
                // add in the local watchlist combobox
                this.cmbWatchlist.gotxComboBox.addItem({
                    text: newWatchlist,
                    id: newWatchlist,
                    isCustom: true,
                    isDefault: false,
                });
                this.cmbWatchlist.gotxComboBox.val(newWatchlist);
                // add in the watchlist model
                this.services.dataStore.addWatchlist(newWatchlist, true);
                this.showMessage("errMsgDiv", "Watchlist added succesfully");
                // document.getElementById('errMsgDiv').innerHTML = "Watchlist added succesfuly";
            }
        }

    }

    removeWatchlist() {
        // this.GotxGrid.gotxGrid.selectrow(1);
        // this.GotxGrid.gotxGrid.selectrow(3);
        // this.GotxGrid.gotxGrid.selectrow(4);
        // this.GotxGrid.gotxGrid.selectrow(7);
        if (this.cmbWatchlist.gotxComboBox.getSelectedItem() == null) {
            this.showMessage("errMsgDiv", "Watchlist not available");
            // document.getElementById('errMsgDiv').innerHTML = "Watchlist not available";
        } else {
            let params = {
                title: "Warning",
                message: "Are you sure you want to delete watchlist",
                buttons: ["OK", "Cancel"],
                buttonAction: ["ok", "close"],
                buttonClass: ["btn btn-danger", "btn btn-primary"],
                type: "Alert",
            };

            const modalRef = this.services.openModal(
                gotxModalComponent,
                "sm",
                params,
                "Gotx Popup"
            );
            modalRef.result.then(
                (res) => {
                    if (res == "ok") {
                        let delteWatchlist =
                            this.cmbWatchlist.gotxComboBox.getSelectedItem().value;
                        let idx = this.cmbWatchlist.gotxComboBox.getSelectedIndex();
                        // remove in the local watchlist combobox
                        this.cmbWatchlist.gotxComboBox.removeAt(idx);
                        this.cmbWatchlist.gotxComboBox.selectIndex(0);
                        // remove in the watchlist model
                        this.services.dataStore.removeWatchlist(delteWatchlist);

                        // **UserPreference
                        delete this.services.UserPreference.userPreference[delteWatchlist];
                        // save to D/b
                        this.userPreferenceService.saveUserPreference();
                        const messageToSend = 'Hello from Component A inside someFunction!';
                        // Send the message via the service
                        this.services.dataStore.delWatchlist(messageToSend);
                    }
                },
                (error) => {
                    console.log("reason", error);
                }
            );
        }
    }

    setCheckDataOnProductChange(){
        this.GotxGrid.gotxGrid.clearselection();
        var prodSelected = this.ProductFromDropDown = this.cstmProduct.cmbProduct.getFieldValue();
        /*if(this.InitialWatchlist.length != 0){
            let rows = this.GotxGrid.gotxGrid.getrows();
            this.InitialWatchlist.forEach((el) => {rows.filter((rowElmt) => {
                        if (
                            el.symbol === rowElmt.symbol &&
                            el.exch === rowElmt.exch &&
                            el.product === rowElmt.product &&
                            el.board === rowElmt.board
                        ) {
                            this.GotxGrid.gotxGrid.selectrow(rowElmt.uid);
                        }
                    }) 
                });
        }else {
     } */
    }

    setGridData() {

        if (this.cmbWatchlist.gotxComboBox.getSelectedItem() == null) {
            this.showMessage(
                "errMsgDiv2",
                "Select/Add a watchlist first to add stocks"
            );
        } else { 
            let rowIndexes = this.GotxGrid.gotxGrid.getselectedrowindexes();
            if (rowIndexes != null && rowIndexes.length > 0) {
                let stockKey = "";
                rowIndexes.forEach((indx) => {
                    let row = this.GotxGrid.gotxGrid.getrowdata(indx);
                    console.log("new3 444 row.product",row.product);
                    stockKey = row.exch + "#" + row.product + "#" + row.board + "#" + row.symbol;

                    if (this.services.dataStore.stockMasterMap.has(stockKey)) {
                        this.stockInWatchlist.push(
                            this.services.dataStore.stockMasterMap.get(stockKey)
                        );
                    }

                    if (this.stockInWatchlist.length > 0) {
                        this.returnDataForWatchlist = "true";
                        this.showMessage("errMsgDiv2", "Save selected");
                    } else {
                        this.returnDataForWatchlist = "false";
                    }
                });
            } else {
                this.returnDataForWatchlist = "false";
            }
        }
    }

    marketWatchStockSubs(stockInWatchlist) {
      console.log("inside sub stocks...>",stockInWatchlist);
      let reqStocks = [];
      stockInWatchlist.forEach(element => {
        reqStocks.push({ "Symbol": element.exchSymbol, "Exch": element.exch, "Product": element.product });
      });
      console.log("reqStocks in sub...>",reqStocks);
      this.services.dataStore.subbedStocks = reqStocks;
      this.marketService.marketWatchStockSubs(reqStocks);
    }

    saveWatchlist() {
         if (this.cmbWatchlist.gotxComboBox.getSelectedItem() == null) {
                this.showMessage('errMsgDiv2', "Select/Add a watchlist first to add stocks");
            } else {
                var selectedWatchlist = this.cmbWatchlist.gotxComboBox.getSelectedItem().value;
                let rowIndexes = this.GotxGrid.gotxGrid.getselectedrowindexes();
                console.log("rowIndexes length",rowIndexes.length);
                if (rowIndexes.length > 30) { //added by shanmugapriya
                  this.showMessage('errMsgDiv2', "You cannot select more than 30 stocks in the watchlist.");
                  return;
                }
                if (rowIndexes != null && rowIndexes.length > 0) {
                    let stockInWatchlist = [];
                    let stockKey = "";
                    let gridProduct = "";
                    rowIndexes.forEach(indx => {
                        let row = this.GotxGrid.gotxGrid.getrowdata(indx);
                        //console.log("new3 333 row.product",row.product);
                        //if(row.product == "FUTSTK" || row.product == "OPTSTK"){ //commented by shanmugapriya
                        if(row.product == "FUTSTK" || row.product == "OPTSTK" || row.product == "FUTIDX" || row.product == "OPTIDX"){
                            gridProduct = "FUTOPT";
                        } else if (row.product == "FUTCOM" || row.product == "OPTCOM" ){ //added by shanmugapriya
                            gridProduct = "COMDERV";
                        } else {
                            gridProduct = row.product;
                        }
                        //console.log("Final grid Product");
                        stockKey = row.exch + "#" + gridProduct + "#" + row.board + "#" + row.symbol;
                        let prodFut=["FUTSTK","FUTIDX","FUTCOM"];
                        if(prodFut.some(item=>row.symbol.includes(item))){
                            this.InitialWatchlist=this.InitialWatchlist.filter(item => !prodFut.some(type=>item.symbol.includes(type)));
                        } else {
                            this.InitialWatchlist=this.InitialWatchlist.filter(item => prodFut.some(type=>item.symbol.includes(type)));
                        }
                        if (this.services.dataStore.stockMasterMap.has(stockKey)) {
                            if(!stockInWatchlist.includes(this.services.dataStore.stockMasterMap.get(stockKey))){
                              stockInWatchlist.push(this.services.dataStore.stockMasterMap.get(stockKey));
                            }
                            
                        }
                    });
                    var totalProductSource = this.services.dataStore.getcmbProductderivative();
                    console.log("totalProductSource len",totalProductSource.length);
                    console.log("InitialWatchlist len..." ,this.InitialWatchlist.length);
                    if(this.InitialWatchlist != undefined){
                        if(totalProductSource.length > 1 && this.InitialWatchlist.length > 0){
                            for(let i=0; i < this.InitialWatchlist.length ; i++){
                                stockInWatchlist.push(this.InitialWatchlist[i]);
                            }
                            
                        }
                    } //actual working code commented by pooja to check 
                    //added by pooja starts
                   /*if(this.InitialWatchlist != undefined){
                        if(totalProductSource.length > 1 && this.InitialWatchlist.length > 0){
                            for(let i=0; i < this.InitialWatchlist.length ; i++){
                                for(let j=0; j < this.stockInWatchlist.length ; j++){
                                    if(this.InitialWatchlist[i].symbol != stockInWatchlist[j].symbol) {
                                    this.InitialWatchlist = this.InitialWatchlist[i];
                                        //stockInWatchlist.push(this.InitialWatchlist[i]);
                                    }
                                }
                            }
                            stockInWatchlist.push(this.InitialWatchlist);
                        }
                    } *///added by pooja ends
                   console.log("stockInWatchlist length",stockInWatchlist.length);
                   console.log("stockInWatchlist datas....>",stockInWatchlist);
                   if (stockInWatchlist.length > 30) { //added by shanmugapriya
                      this.showMessage('errMsgDiv2', "You cannot select more than 30 stocks in the watchlist.");
                      return;
                    }
                    this.marketService.unSubscribeMarket(this.services.dataStore.subbedStocks);

                    this.services.dataStore.watchListMap.set(selectedWatchlist, stockInWatchlist);
                    this.marketWatchStockSubs(stockInWatchlist);
                   // if(!this.isfromproductChange){
                        //this.isfromproductChange = false;
                    this.showMessage('errMsgDiv2', "Stocks added to watchlist succesfully");
                   // }
                    // document.getElementById('errMsgDiv2').innerHTML = "Stocks added to watchlist succesfully";
    
                    // **UserPreference
                    this.services.dataStore.getWatchList().forEach(element => {
                        if (selectedWatchlist == element.id && this.chckDefault.getFieldValue()) {
                            element.isDefault = true;
                        } else {
                            element.isDefault = false;
                        }
                    });
                    // save to D/b
                    this.userPreferenceService.saveUserPreference();
                } else {
                   // if(!this.isfromproductChange){
                        //this.isfromproductChange = false;
                    this.showMessage('errMsgDiv2', "Please select atleast one stock to save");
                  //  }
                    // document.getElementById('errMsgDiv2').innerHTML = "Please select atleast one stock to save";
                }
            }

      /*  this.setGridData();
        if (this.returnDataForWatchlist == "true") {
            this.services.dataStore.watchListMap.set(
                this.selectedWatchlist,
                this.stockInWatchlist
            );
            this.showMessage("errMsgDiv2", "Stocks added to watchlist succesfully");
            // save to D/b
            this.userPreferenceService.saveUserPreference();
        } else {
            //this.setGridData();
            document.getElementById("errMsgDiv2").innerHTML =
                "Please select atleast one stock to save";
        }*/
    }

    watchlistChange(selectedWatchlist) {
        //var selectedWatchlistData = this.services.dataStore.watchListMap.get(selectedWatchlist);
        this.GotxGrid.gotxGrid.clearselection();
        let rows = this.GotxGrid.gotxGrid.getrows();
        if (this.services.dataStore.watchListMap.has(selectedWatchlist)) {
            // **UserPreference
            this.chckDefault.setValue(false);
            this.services.dataStore.getWatchList().forEach((element) => {
                if (selectedWatchlist == element.id && element.isDefault) {
                    this.chckDefault.setValue(true);
                }
            });

            this.services.dataStore.watchListMap.get(selectedWatchlist).forEach((el) => {
                    rows.filter((rowElmt) => {
                        if (
                            el.symbol === rowElmt.symbol &&
                            el.exch === rowElmt.exch &&
                            el.product === rowElmt.product &&
                            el.board === rowElmt.board
                        ) {
                            this.GotxGrid.gotxGrid.selectrow(rowElmt.uid);
                        }
                    });
                });

            this.InitialWatchlist = this.services.dataStore.getCustomWatchlistMap(selectedWatchlist);
            //console.log("----------this.InitialWatchlist",this.InitialWatchlist) ;
            this.ProductFromDropDown = this.cstmProduct.cmbProduct.getFieldValue().text;
            for (let i = this.InitialWatchlist.length - 1; i >= 0; i--) {
                //console.log("----------inside for") ;
                if(this.ProductFromDropDown != "EQUITY" && this.InitialWatchlist[i].product != "EQUITY"){
                    this.InitialWatchlist[i].product = this.services.dataStore.convertProductMap(this.InitialWatchlist[i].underlyingType);
                }
                if (this.ProductFromDropDown == this.InitialWatchlist[i].product) {
                    this.CurrentWatchlist.push(this.InitialWatchlist[i]);
                    this.InitialWatchlist.splice(i, 1);
                   
                }
             
            }
            //console.log("---this.CurrentWatchlist" ,this.CurrentWatchlist);
            //console.log("---this.InitialWatchlist" ,this.InitialWatchlist);
        }
    }

    closeWatchlist() {
        if (this.cmbWatchlist.gotxComboBox.getSelectedItem() != null) {
            this.activeModal.close(
                this.cmbWatchlist.gotxComboBox.getSelectedItem().value
            );
        } else {
            this.activeModal.close("close");
        }
    }

    async cstmExchange_exchSelected(event) {
        let inputMap = new Map();
        this.reloadStock();
    }
    async cstmProduct_productSelected(event) {
      
        //this.setGridData();
        //this.setCheckDataOnProductChange();
       // if(!this.isfromproductChange){
            //this.isfromproductChange = false;  
        if (this.cmbWatchlist.gotxComboBox.val() == "") {
            this.showMessage("errMsgDiv", "Please select a watchlist");
        }else{
            this.showMessage("errMsgDiv", "Watchlist is being saved.."); 
            //this.isfromproductChange = true;  
            this.saveWatchlist();
            this.reloadStock();
            this.watchlistChange(this.cmbWatchlist.gotxComboBox.getSelectedItem().value);
    }
//}
    }
    onStockSelected(event) {
        if (event == undefined || event == null || event == "") {
            this.GotxGrid.gotxGrid.clearfilters();
        } else {
            let filtergroup = new jqx.filter();

            let filtervalue = event;
            let filtercondition = "contains";

            let filter1 = filtergroup.createfilter(
                "stringfilter",
                filtervalue,
                filtercondition
            );

            let filter_or_operator = 1;
            filtergroup.addfilter(filter_or_operator, filter1);

            // add the filters
            if (this.cmbStock.searchMode == "companyName") {
                this.GotxGrid.gotxGrid.addfilter("companyName", filtergroup, true);
            } else {
                this.GotxGrid.gotxGrid.addfilter("symbol", filtergroup, true);
            }
            // apply the filters
            this.GotxGrid.gotxGrid.applyfilters();
        }
    }

    onSearchModeSelected(searchmode) {
        // this.searchMode = searchmode;
        this.reloadStock();
    }
    updatedStockSource: any[];
    reloadStock() {
        if (this.cstmExchange != undefined) {
            // this.source = this.services.dataStore.getcmbStockInput(exch, pdct);
            this.cmbStock.gotxInput.val("");
            let exch = this.cstmExchange.cmbExchange.getFieldValue();
            let pdct = this.cstmProduct.cmbProduct.getFieldValue();
            let pdctSel = this.cstmProduct.cmbProduct.getFieldValue();
            if (typeof pdct == 'object' ){
                pdct = pdct.text
            }
            
            let board = "";
            //let board = "AL";
            if (pdct == "EQUITY" || pdct == "DEBT") {
                //board = "AL";
                board = "NR";
            } else {
                board = "NR";
            }
            
            pdct = this.services.dataStore.getDerivativeTypeConverter(pdct);
            this.updatedStockSource = this.services.dataStore.getcmbStockInput(
                this.cmbStock.searchMode,
                exch,
                pdct,
                board
            );
            this.cmbStock.source = this.updatedStockSource;
            this.GotxGrid.reloadGrid(this.updatedStockSource);
            this.cstmProduct.cmbProduct.dropDownOptions.Options = this.services.dataStore.getcmbProductderivative();
            this.cstmProduct.cmbProduct.setValue(pdctSel);
        }
        // this.saveWatchlist();
    }

    
    watchDatafields = [{ name: "id" }, { name: "text" }];
    transalte(text) {
        return this.services.translate.instant(text);
    }
    data = this.services.dataStore.stockMaster;
    datafields = [
        { name: "symbol", type: "string" },
        { name: "exch", type: "string" },
        { name: "product", type: "string" },
        { name: "board", type: "string" },
        { name: "currency", type: "string" },
        { name: "companyName", type: "string" },
    ];
    rowId = "orderrefnumber";
    datatype = "json";
    //   linkrenderer = ()=>{};
    columns: any[] = [
        // { text: 'Options', cellsalign: 'right', cellsrenderer: this.linkrenderer, width: 100 },
        {
            text: this.transalte("WatchListGrid.Stock"),
            datafield: "symbol",
            width: 250,
            cellsalign: "left",
        },
        {
            text: this.transalte("WatchListGrid.Exchange"),
            datafield: "exch",
            width: 100,
            cellsalign: "left",
        },
        {
            text: this.transalte("WatchListGrid.Product"),
            datafield: "product",
            width: 100,
            cellsalign: "left",
        },
        {
            text: this.transalte("WatchListGrid.Board"),
            datafield: "board",
            width: 100,
            cellsalign: "left",
            cellsrenderer: function (row, datafield, value) {
                let cellValueContainer =
                    '<div class="jqx-grid-cell-left-align" style="margin-top: 9px;">';
                if (value == "NR") {
                    cellValueContainer += " <p class='cellClass'>Normal</p>";
                } else if (value == "SP") {
                    cellValueContainer += "<p class='cellClass'>Spot</p>";
                } else if (value == "OD") {
                    cellValueContainer += "<p class='cellClass'>OdLot</p>";
                } else if (value == "BK") {
                    cellValueContainer += "<p class='cellClass'>Bulk</p>";
                } else if (value == "AU") {
                    cellValueContainer += "<p class='cellClass'>Auction</p>";
                } else if (value == "FR") {
                    cellValueContainer += "<p class='cellClass'>Foreign</p>";
                } else if (value == "AT") {
                    cellValueContainer += "<p class='cellClass'>ATB</p>";
                } else if (value == "SM") {
                    cellValueContainer += "<p class='cellClass'>SME</p>";
                }
                cellValueContainer += "</div>";
                return cellValueContainer;
            },
        },
        {
            text: this.transalte("WatchListGrid.Currency"),
            datafield: "currency",
            width: 100,
            cellsalign: "left",
        },
        {
            text: this.transalte("WatchListGrid.Company"),
            datafield: "companyName",
            cellsalign: "left",
        },
    ];
}
